$(document).on('turbo:load', function() {

  $('#cd-invites, #cd-confirmation, #won-deal, #held-unit').on('click', function (e) {
    let currentActiveTab = $(e.target).attr('id');
    $('.active_tab').val(currentActiveTab);

    // Update the active_tab param of the sort links
    $('th a').each(function () {
      let href = $(this).attr('href');
      let url = new URL(href, window.location.origin);
      url.searchParams.set('active_tab', currentActiveTab);
      $(this).attr('href', url);
    });
  });

  // Trigger when the filter button is clicked
  $('#filter-form').on('submit', function () {
    let currentActiveTab = $('.nav-link.active').attr('id');
    $('.active_tab').val(currentActiveTab);
  });

  $('.filter_form').hide();

  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    let activeTab = $(e.target).attr("href");

    // Show the form when the "Won Deals" tab is selected and hide it otherwise
    $('.filter_form').toggle(activeTab == "#won-deals");

    // Persist the active tab in the session storage
    sessionStorage.setItem('activeTab', activeTab);
  });

  let activeTab = sessionStorage.getItem('activeTab');

  // Show the form when the "Won Deals" tab was active before page reload
  $('.filter_form').toggle(activeTab == "#won-deals");

  // Make the corresponding tab active
  if (activeTab) {
    $('a[href="' + activeTab + '"]').tab('show');
  }

});
